import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const openStationery = async (data: stdObject, params: stdObject) => {
  console.log("openStationery", data);
  const { setDocValues, setStationeryModal, setMsg, closeMsg, logoutAction } =
    params;
  if (data.code === "new") {
    setMsg("loading");
    const payloadOpenStationery = data;
    console.log("payloadOpenStationery", payloadOpenStationery);
    const responseOpenStationery = await sendData({
      endPoint: "callStationery",
      payload: payloadOpenStationery,
      logoutAction,
    });
    console.log("responseOpenStationery", responseOpenStationery);
    if (responseOpenStationery.status && responseOpenStationery.success) {
      data = {
        code: "new",
        area: responseOpenStationery.area,
        data: responseOpenStationery.data,
        parts: responseOpenStationery.parts,
        doc: responseOpenStationery.doc,
        rows: responseOpenStationery.rows,
        person: responseOpenStationery.person,
        payments: responseOpenStationery.payments,
        prices: responseOpenStationery.prices,
        index: -1,
      };
    }
  } else if (data.code === "init") {
    data = {
      code: "new",
      area: data.area,
      data: data.data,
      parts: data.parts,
      doc: data.doc,
      rows: data.rows,
      person: data.person,
      payments: data.payments,
      prices: data.prices,
      index: -1,
    };
  }
  if (data.area) {
    setDocValues(data);
    setStationeryModal("stationery");
  }
  if (data.code === "new") {
    closeMsg();
  }
};
